import { useEffect } from 'react';
import { ConfigProvider, App as AntApp } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import { antdTheme } from './theme';
import { queryClient } from '@/api/query';
import { router } from '@/router';
import { useAuth } from '@/stores/auth';

dayjs.locale('zh-cn');

function Bootstrap() {
  const bootstrap = useAuth((s) => s.bootstrap);
  useEffect(() => {
    void bootstrap();
  }, [bootstrap]);
  return <RouterProvider router={router} />;
}

export function App() {
  return (
    <ConfigProvider
      theme={antdTheme}
      locale={zhCN}
      // 中文界面不要在中文字符间自动插空格（Skill tokens.md 铁律 6）
      button={{ autoInsertSpace: false }}
    >
      <AntApp>
        <QueryClientProvider client={queryClient}>
          <Bootstrap />
        </QueryClientProvider>
      </AntApp>
    </ConfigProvider>
  );
}
